import {get,post} from '../http';
const cclive = {
    getRoomDesc:params => post('/app/live/getRoomDesc.json',params),
    getRoomInfo:params => post('/app/live/getroominfo.json',params),
    getRoomDetail:params => post('/app/live/getRoomDetails',params),
    getshowNumber:params => post('/app/live/data/usernumber.json',params),//shownumber为2时，获取人数为后台配置人数
    scoreProblems:params => post('/app/live/score/problems.json',params),//评分数据
    scoreSave:params => post('/app/live/score/save.json',params),//保存评分数据
    getplayType:params => post('/app/live/playcode/playtype',params),//获取播放类型
    playcodeBand:params => post('/app/live/playcode/banding',params),//直播绑定播放码
    getRoomStatus:params => post('/app/live/getRoomStatus.json',params),//
    endTip:params => post('/app/live/end/guide',params),//直播结束提醒
    getGoodNotes:params => post('app/user/note/course/good.json', params),//获取优秀笔记
    getAiComment:params => post('/app/ai/comments/list',params),//获取ai评论
    getLightBoard:params => post('/app/live/identity/light/settings',params),//获取直播灯牌信息
    getAiregistration:params => post('/app/live/ai/registration/settings',params),//获取直播智能报名
    liveSignUp:params => post('/media/phone/wx/live/usersign.json',params),//直播报名
    liveTabsInfo:params => post('/app/live/tab/settings',params),//直播点播tab定位信息
}
export default cclive;


// WEBPACK FOOTER //
// ./src/cmtapp/request/api/cclive.js